import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import AuthService from '../../services/auth'
import Loading from '../loading'
import StoreService from '../../services/ephemeral-store'

export default class RedirectPortalRoute extends Component {

    static propTypes = {
        path: PropTypes.string
    }

    constructor(props) {
        super(props)
        this.state = {
            shouldRedirect: false, 
            redirectUrl: ''
        };
    }

    
    componentDidMount = async() => {
        const store = new StoreService();
        await AuthService.getToken().then((token)=>{
            store.get('workspace').then((workspace)=>{
                let accountOrn = JSON.parse(workspace).accountOrn.split(':');
                const currentDomain = window.location.hostname;
                let aiqDomain = 'https://aiqauto.com/';
                let directDomain = 'https://myatomdirect.com/Default.aspx/';
                let driveDomain = 'https://my.drive.video/#/';
                // Check if the current domain is "staging.gsm.auto"
                if (currentDomain.toLowerCase() === 'staging.gsm.auto') {
                    aiqDomain = 'https://facelift.drivehelix.com/';
                    driveDomain = 'https://dev.drive.video/#/';
                    directDomain = 'https://staging.myatomdirect.com/Default.aspx/';
                } 
                if(this.props.path=='/atom/audienceIQ'){
                    this.setState({redirectUrl: aiqDomain + "scripts/authLanding.php?token=" + token + "&entityId=" + accountOrn[2]});
                }
                if(this.props.path=='/atom/drive'){
                    this.setState({redirectUrl: driveDomain + "?token=" + token + "&entityId=" + accountOrn[2]});
                }
                if(this.props.path=='/atom/atomDirect'){
                    this.setState({redirectUrl: directDomain + "?token=" + token + "&entityId=" + accountOrn[2]});
                }
                this.setState({shouldRedirect: true });
            });
        })
    }

    render() {
        if (this.state.shouldRedirect) {
            window.location = this.state.redirectUrl ;
        }
        return (
            <Loading label="redirecting..." />
          );

      }

}



// WEBPACK FOOTER //
// src/components/auth/redirect-portal-route.js